// version.ts
//
// Numero unico para os quatro modulos: eles sao publicados juntos e usados juntos. Cada um
// com o seu (1.0.7, 1.0.9, 1.0.13) obrigava a perguntar "a versao de qual tela?" no meio
// do evento, que e o pior momento possivel para essa duvida.
export const APP_VERSION = 'v1.1.0';
